import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {
  users: any[] = [];
  displayedUsers: any[] = [];
  itemsPerPage: number = 15;
  currentPage: number = 1;
  totalItems: number;
  sortDirection: string = 'asc';
  searchText: string = '';
  mathLib: any = Math;

  ngOnInit() {
    this.fetchUserData();
    this.totalItems = this.users.length;
    this.updateDisplayedUsers();
  }
  

  fetchUserData() {
    // Replace this with your actual user data fetching logic
    // Example data for illustration purposes
    this.users = [
      { userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },
      { userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },{ userName: 'hi', email: 'hi@gmail.com', phone: '980987' },
      { userName: 'hello', email: 'hello@gmail.com', phone: '9898954' },
    ];
  }

  sortColumn(column: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.users.sort((a, b) => {
      const valueA = a[column].toLowerCase();
      const valueB = b[column].toLowerCase();
      return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
    this.updateDisplayedUsers();
  }

  updateDisplayedUsers() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.displayedUsers = this.filterUsers(this.users).slice(startIndex, endIndex);
  }
  getPages(): number[] {
    const totalPages = this.mathLib.ceil(this.totalItems / this.itemsPerPage);
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  onPageChange(page: number) {
    if (page >= 1 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
      this.currentPage = page;
      this.updateDisplayedUsers();
    }
  }

  onSearch() {
    this.currentPage = 1;
    this.updateDisplayedUsers();
  }

  filterUsers(users: any[]): any[] {
    return users.filter(user =>
      user.userName.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }
}
